// extracted by mini-css-extract-plugin
export default {"footerLeft":"FooterLeft_footerLeft__oMAeA","brand":"FooterLeft_brand__r3T1a","text":"FooterLeft_text__Aqr5Z"};